import React from "react";
import SectionOne from "../components/SectionOne";
import SectionTwo from "../components/SectionTwo";
// import toast, { Toaster } from "react-hot-toast";

const Home = () => {
  return (
    <div>
      <SectionOne />
      {/* <SectionTwo fetchURL="https://script.google.com/macros/s/AKfycbwAAkxI1yBtlHE1SnRJz7d63ENx9aWhFOrPipTFzdn0_yRA0JLWYP6SDkFIg0f48ehz/exec" /> */}
      <SectionTwo fetchURL="https://bookstoreapi-u5pi.onrender.com/data" />
      {/* <SectionThree />
            <SectionFour /> */}
      {/* https://docs.google.com/spreadsheets/d/1528Zi3W8elgnE6rWTXAsAZ6ay7qbcHnl87Hx4amBTSA/edit?usp=sharing */}
    </div>
  );
};

export default Home;
